import { SET_USER_DETAILS, UPDATE_USER_DETAILS } from "../types/auth.types";

const INITIAL_STATE = {
  userDetails: {},
  token: null,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_USER_DETAILS:
      return {
        ...state,
        userDetails: action.data,
        token: action.token,
      };
    case UPDATE_USER_DETAILS:
      return {
        ...state,
        userDetails: action.user,
      };
    default:
      return state;
  }
};

export default reducer;
